import { ncbData } from '../../api';

const CHECKINS_TABLE = 'event_guest_checkins_1778600000';

export async function loadEventCheckIns(eventId) {
  const response = await ncbData('read', CHECKINS_TABLE, {
    event_id: String(eventId),
  });

  if (response?.status !== 'success') return response;

  return {
    ...response,
    data: Array.isArray(response?.data) ? response.data : [],
  };
}

export async function createWalkInCheckIn({ event, memorial, guestName, guestEmail, partySize }) {
  const now = new Date().toISOString();

  return ncbData('create', CHECKINS_TABLE, {
    event_id: String(event?.id ?? ''),
    memorial_id: String(memorial?.id ?? ''),
    memorial_name: memorial?.name ?? '',
    guest_name: guestName.trim(),
    guest_email: guestEmail.trim() || null,
    rsvp_status: 'attending',
    party_size: partySize,
    checked_in: 1,
    checked_in_at: now,
    created_at: now,
    updated_at: now,
  });
}

export async function updateCheckInStatus(guest, checkedIn) {
  if (guest?.id === null || guest?.id === undefined) {
    return { status: 'error', data: null, error: 'This guest record has no database ID.' };
  }

  return ncbData('update', `${CHECKINS_TABLE}/${guest.id}`, {
    checked_in: checkedIn ? 1 : 0,
    checked_in_at: checkedIn ? new Date().toISOString() : null,
    updated_at: new Date().toISOString(),
  });
}